import React from 'react';
import './AboutPage.scss';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-page__container">
        <h1 className="about-page__title">About $HTROM</h1>
        
        <div className="about-page__content">
          <p>
            $HTROM was established in Tampa, Florida in 2021 as a response to excess 
            and repetition.
          </p>
          <p>
            We draw from the visual language of finance and power to explore identity, 
            presence, and control.
          </p>
          <p>
            Designed for those who move between worlds — never confined to one.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
